require('@noardcode/vakantieadressen-widget');